import { useQuery } from "react-query";
import {
  getEmployeeTitle,
  getEmployeeTitleFilter,
} from "../../../../../actions/Utilities/EmployeeTitle";

export const useEmployeeTitle = () => {
  return useQuery("GetEmployeeTitle", getEmployeeTitle, {
    refetchOnWindowFocus: false,
  });
};

export const useEmployeeTitleFilter = () => {
  return useQuery("GetEmployeeTitleFilter", getEmployeeTitleFilter, {
    refetchOnWindowFocus: false,
  });
};
